'use strict';

exports.__esModule = true;
exports.Node = exports.flatten = undefined;

var _flatten = require('./flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _node = require('./node');

var _node2 = _interopRequireDefault(_node);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// IE8 compatibility output
exports.flatten = _flatten2['default'];
exports.Node = _node2['default'];